import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

const DocsPageUnorderedList: FunctionComponent = ( { ...rest } ) =>
{
    return <DocsPageUnorderedListWrapper {...rest} />
};

export default DocsPageUnorderedList;

const DocsPageUnorderedListWrapper = styled.ul`
`;
